import { gql } from '@apollo/client'

export const BROADSIGN_CREATION_MEDIA_TREE = gql`
  query BroadsignCreationMediaTree($id: ID!) {
    broadsignCreationMediaTree(id: $id) {
      id
      name
      type
      children {
        id
        name
        type
        children {
          acceptanceStatus
          id
          name
          type
          children {
            id
            type
            used
          }
        }
      }
    }
  }
`
